import React from 'react'
import { Grid } from '@material-ui/core'
import { a11yProps, Tab, Tabs } from 'asterX-UI/Tabs'
import StandardTable from 'asterX-UI/Table/StandardTable'
import { useHomeStoreRop } from 'context/HomeStore/Rop'
import { formatTime } from 'lib/utils'

const columns = [
  [
    'Отдел',
    'Сотрудники в смене',
    'Текущая очередь',
    'Ср. время в текущей очереди',
    'Ср. время ожидания в очереди (за сегодня)',
    'Приглашено',
    'Ср. время ожидания клиента',
    'Сейчас обслуживают',
    'Ср. время обслуживания (за сегодня)',
    'Всего обслужено клиентов'
  ],
  [
    'Филиал',
    'Отдел',
    'Сотрудник',
    'Ср. время ожидания в очереди (за сегодня)',
    'Приглашено',
    'Ср. время ожидания клиента',
    'Сейчас обслуживают',
    'Ср. время обслуживания (за сегодня)',
    'Всего обслужено клиентов'
  ],
  [
    'ID талона',
    'Номер талона',
    'Филиал',
    'Отдел',
    'Сотрудник',
    'Имя клиента',
    'Текущий статус',
    'Время ну статусе',
    'Метка длительности',
    'Общее время обслуживания'
  ]
]
const RopInfoTable = () => {
  const {
    homeStore: { selectedTabTable, listDepartments, listManagers, seoList },
    homeStoreFunc: { setSelectedTabTable }
  } = useHomeStoreRop()

  const rows = [[], [], []]

  const mapAndPush = (items, rowIndex, mappingFunction) => {
    const mappedRows = items.map(mappingFunction)
    mappedRows.forEach(item => {
      rows[rowIndex].push(item)
    })
  }

  const mapListDepartments = item => [
    item?.department,
    item?.manager_count,
    item?.count_in_queue,
    formatTime(item?.avg_current_queue_time),
    formatTime(item?.avg_queue_time),
    item?.count_invited,
    formatTime(item?.avg_invited_time),
    item?.count_in_service,
    formatTime(item?.avg_current_in_service_time),
    item?.count_ended
  ]
  mapAndPush(listDepartments, 0, mapListDepartments)

  const mapListManagers = item => [
    item.branch,
    item.department,
    item.manager,
    formatTime(item.avg_queue_time),
    item.count_invited,
    formatTime(item.avg_invited_time),
    item.count_in_service,
    formatTime(item.avg_current_in_service_time),
    item.count_ended
  ]
  mapAndPush(listManagers, 1, mapListManagers)

  const mapSeoList = item => {
    const statusTimeMap = {
      ended: item?.total_time,
      invited: item?.invite_time,
      in_queue: item?.queue_time,
      in_service: item?.service_time
    }

    const formattedTime = statusTimeMap[item?.status]
      ? formatTime(statusTimeMap[item?.status])
      : '0'

    return [
      item?.ticket_id,
      item?.seo_number,
      item?.branch,
      item?.department,
      item?.manager,
      item?.client_name,
      item?.status,
      formattedTime,
      item?.q_tag,
      formatTime(item?.total_time)
    ]
  }

  if (seoList && seoList.list) {
    mapAndPush(seoList.list, 2, mapSeoList)
  }

  return (
    <Grid item container xs={12} md={12}>
      <Grid item xs={12} md={12}>
        <Tabs
          style={{ margin: '10px' }}
          value={selectedTabTable}
          onChange={(e, newValue) => setSelectedTabTable(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {[
            'Сводная по отделам',
            'Сводная по МОПам',
            'Детальная информация'
          ].map((e, i) => (
            <Tab
              key={`rop-tab-${i}`}
              label={e || ''}
              value={i}
              {...a11yProps(i)}
            />
          ))}
        </Tabs>
      </Grid>
      <Grid item xs={12} md={12}>
        <StandardTable
          tableData={{
            names: columns[selectedTabTable],
            rows: rows[selectedTabTable]
          }}
        />
      </Grid>
    </Grid>
  )
}
export default RopInfoTable
